var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-table-wrapper",class:{ 'no-border': _vm.noBorder },style:(_vm.wrapperStyle)},[_c('table',{staticClass:"common-table",class:_vm.tableClass},[_c('thead',[_vm._t("header",function(){return [_c('tr',[_vm._t("header-cells")],2)]})],2),_c('tbody',[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }